import bookingMenu from './BookingMenu';

export default bookingMenu;



// WEBPACK FOOTER //
// ./scripts/blocks/bookingMenu/index.js